<script>
  import { createEventDispatcher } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import Constantes from '../../Classes/Constantes.js';
  import { tenantLogado } from '../../Classes/Stores.js';

  const dispatch = createEventDispatcher();
  const conexao = new Conexoes();
  $: tenant = $tenantLogado;

  let dataInicio = '';
  let dataFim = '';
  let diasSelecionados = [];
  let horariosInicio = [{ hora: '' }];
  let localAtendimento = '';
  export let locais = [];
  let enderecoAtendimento = '';
  const diasDaSemana = ['Domingo','Segunda','Terça','Quarta','Quinta','Sexta','Sábado'];

  function handleDiaChange(dia) {
    diasSelecionados = diasSelecionados.includes(dia) ? diasSelecionados.filter(d => d !== dia) : [...diasSelecionados, dia];
  }

 async function criarHorarios() {
    if (!dataInicio || !dataFim || diasSelecionados.length === 0 || !horariosInicio[0].hora) {
      dispatch('recarregar', Constantes.msg_campos_obrigatorios);
      return;
    }

    // NOVA VALIDAÇÃO: Impede que a data final seja menor ou igual à inicial
    if (dataFim <= dataInicio) {
      dispatch('recarregar', 'A data final deve ser no mínimo um dia superior à data inicial.');
      return;
    }

    dispatch('loading', true);
    const [nomeSeparado, enderecoSeparado] = localAtendimento.split('|');

    const res = await conexao.conecta(Constantes.api_criar_horarios, {
      body: { 
        id_tenant: tenant.id, 
        dataInicio, dataFim, diasSelecionados, horariosInicio, 
        local: nomeSeparado || 'Padrão',
        endereco: enderecoSeparado || '' 
      }
    });
    dispatch('loading', false);
    dispatch('recarregar', res?.mensagem || 'Horários gerados!');
  } 
</script>

<section class="card-panel fade-in">
  <h2>Gerar Horários em Massa</h2>
  <div class="form-grid">
  <div class="grid-full">
      <div style="display: flex; justify-content: space-between; align-items: end; margin-bottom: 8px;">
        <label style="margin: 0;">Selecione o Local / Modalidade</label>
        <button style="background: none; border: none; color: var(--primary); font-weight: bold; cursor: pointer; font-size: 0.8rem;" on:click={() => dispatch('mudarAba', 'locais')}>
          <i class="fas fa-plus"></i> Novo Local
        </button>
      </div>
      
      <select class="input-app" bind:value={localAtendimento}>
        <option value="">Selecione onde serão as consultas...</option>
        {#each locais as loc}
          <option value="{loc.nome}|{loc.endereco}">{loc.nome}</option>
        {/each}
      </select>
    </div>
      
    <div><label>De:</label><input type="date" class="input-app" bind:value={dataInicio} /></div>
   <div>
  <label>Até:</label>
  <input type="date" class="input-app" bind:value={dataFim} min={dataInicio} />
</div>
    <div class="grid-full">
      <label>Dias da Semana</label>
      <div class="chip-group">
        {#each diasDaSemana as dia, i}
          <button class="chip {diasSelecionados.includes(i) ? 'selected' : ''}" on:click={() => handleDiaChange(i)}>{dia}</button>
        {/each}
      </div>
    </div>
    <div class="grid-full">
      <label>Horários (Ex: 08:00, 09:00)</label>
      {#each horariosInicio as h, i}
        <div class="row-time">
          <input type="time" class="input-app" bind:value={h.hora} />
          {#if i > 0} <button class="btn-del" on:click={() => horariosInicio = horariosInicio.filter((_, idx) => idx !== i)}><i class="fas fa-trash"></i></button> {/if}
        </div>
      {/each}
      <button class="btn-add" on:click={() => horariosInicio = [...horariosInicio, { hora: '' }]}><i class="fas fa-plus"></i> Novo Horário</button>
    </div>
    <div class="grid-full">
      <button class="btn-primary" on:click={criarHorarios}>Gerar Agenda</button>
    </div>
  </div>
</section>

<style>
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
  .grid-full { grid-column: 1 / -1; }
  .radio-toggle { display: flex; background: var(--bg-app); padding: 5px; border-radius: 8px; gap: 5px; }
  .radio-toggle button { flex: 1; border: none; padding: 8px; border-radius: 6px; cursor: pointer; font-weight: 600; font-size: 0.85rem; transition: 0.2s; }
  .radio-toggle button.active { background: white; color: var(--primary); box-shadow: 0 2px 6px rgba(0,0,0,0.05); }
  .chip-group { display: flex; flex-wrap: wrap; gap: 8px; }
  .chip { background: var(--bg-app); border: 1px solid var(--border); padding: 6px 12px; border-radius: 20px; cursor: pointer; font-size: 0.8rem; font-weight: 600; }
  .chip.selected { background: var(--primary); color: white; border-color: var(--primary); }
  .row-time { display: flex; gap: 10px; margin-bottom: 8px; }
  .btn-add { background: none; border: none; color: var(--accent); font-weight: 700; cursor: pointer; font-size: 0.85rem; margin-top: 5px; }
  @media (max-width: 900px) { .form-grid { grid-template-columns: 1fr; } }
  @media (max-width: 640px) {
    .chip-group { gap: 6px; }
    .row-time { flex-direction: column; }
    .row-time .btn-del { align-self: flex-end; }
    .btn-add { width: 100%; text-align: left; }
  }
</style>